import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appResizable]',
  standalone: true
})
export class ResizableDirective {
  
  @Output() resizing = new EventEmitter<number>();
  
  private isResizing = false;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  // Start event for mouse and touch
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    this.onDragStart(event);
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.onDragStart(event);
  }
  
  // Resize event for mouse and touch
  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.onDragMove(event);
  }

  @HostListener('window:touchmove', ['$event'])
  onTouchMove(event: TouchEvent): void {
    this.onDragMove(event);
  }

  // End event for mouse and touch
  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent): void {
    this.onDragEnd(event);
  }

  @HostListener('window:touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    this.onDragEnd(event);
  }


  // LOGICA UNIFICATA per eventi mouse and touch

  private onDragStart(event: MouseEvent | TouchEvent): void {
    event.preventDefault();
    this.isResizing = true;
    this.renderer.addClass(this.el.nativeElement, 'resizing');
  }

  private onDragMove(event: MouseEvent | TouchEvent): void {
    if (!this.isResizing) {
      return;
    }
    
    const clientX = (event instanceof MouseEvent) 
      ? event.clientX 
      : event.touches[0].clientX;
      
    this.resizing.emit(clientX - 80);

    if (event instanceof TouchEvent) {
      event.preventDefault();
    }
  }

  private onDragEnd(event: MouseEvent | TouchEvent): void {
    if (this.isResizing) {
      this.isResizing = false;
      this.renderer.removeClass(this.el.nativeElement, 'resizing');
    }
  }

}
